import React, {useEffect} from 'react';
import {useRouter} from 'next/router';

import {CustomLandingPage} from './CustomLandingPage';
import {useAppContext, useAnalytics} from '../hooks';

const ReferredLandingPage = () => {
  const {hasSubscription} = useAppContext();
  const {tracker} = useAnalytics();
  const router = useRouter();

  useEffect(() => {
    tracker.viewReferralsLanding();
  }, []);

  if (hasSubscription) {
    router.push('/');
    return null;
  }

  return (
    <CustomLandingPage
      id="REFERRALWIN"
      metaDescription="Your friend shared 10% off your Exponent Membership! Join today to ace your interview before the link expires."
      socialDescription="Your friend shared 10% off your Exponent Membership! Join today to ace your interview before the link expires."
      socialThumbnail="https://static.tryexponent.com/save_10_bc6596c151.png"
    />
  );
};

export default ReferredLandingPage;
